import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ProfileFilterMenu } from './ProfileFilterMenu';
import { useCommunityFilter } from '../hook/useCommunityFilter';
import { CommunityFilterDispatchProvider } from '../provider/CommunityFilterDispatchProvider';
import { DiscoveringProfileSection } from './DiscoveringProfileSection';

export const CommunityDiscover = () => {
  const { filterStore, filterDispatch } = useCommunityFilter();

  return (
    <CommunityFilterDispatchProvider filterDispatch={filterDispatch}>
      <Box sx={{ mt: 12 }}>
        <Box sx={{ display: 'flex', gap: 5, alignItems: 'center' }}>
          <Typography variant='subtitle1' sx={{ fontWeight: 500, flex: 1 }}>
            <FormattedMessage id='community.peers.header' />
          </Typography>
          <ProfileFilterMenu communityFilterStore={filterStore} />
        </Box>
        <DiscoveringProfileSection filterStore={filterStore} />
      </Box>
    </CommunityFilterDispatchProvider>
  );
};
